import {
  GET_RESUME_BY_EMP_ID_REQUEST,
  GET_RESUME_BY_EMP_ID_SUCCESS,
  GET_RESUME_BY_EMP_ID_FAILURE,
} from "../actions";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const getResumeByEmpIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RESUME_BY_EMP_ID_REQUEST:
      return {
        ...state,
        loading: true,
        data: [],
      };

    case GET_RESUME_BY_EMP_ID_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case GET_RESUME_BY_EMP_ID_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default getResumeByEmpIdReducer;
